import { useAnnouncements } from '@/hooks/useAnnouncements';
import { AnnouncementCard } from './AnnouncementCard';
import { Skeleton } from '@/components/ui/skeleton';
import { Megaphone, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface AnnouncementsListProps {
  limit?: number;
}

export function AnnouncementsList({ limit = 5 }: AnnouncementsListProps) {
  const { data: announcements, isLoading, error } = useAnnouncements(limit);
  
  if (isLoading) {
    return (
      <section className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <Megaphone className="h-5 w-5 text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Avisos da Empresa</h2>
        </div>
        <div className="space-y-3">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-24 w-full rounded-lg" />
          ))}
        </div>
      </section>
    );
  }
  
  if (error) {
    return (
      <section className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <Megaphone className="h-5 w-5 text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Avisos da Empresa</h2>
        </div>
        <p className="text-sm text-muted-foreground">
          Erro ao carregar avisos. Tente novamente mais tarde.
        </p>
      </section>
    );
  }
  
  if (!announcements || announcements.length === 0) {
    return (
      <section className="mb-8">
        <div className="flex items-center gap-2 mb-4">
          <Megaphone className="h-5 w-5 text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Avisos da Empresa</h2>
        </div>
        <div className="bg-muted/50 rounded-lg p-6 text-center">
          <Megaphone className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
          <p className="text-sm text-muted-foreground">
            Nenhum aviso no momento.
          </p>
        </div>
      </section>
    );
  }
  
  return (
    <section className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Megaphone className="h-5 w-5 text-primary" />
          <h2 className="text-lg font-semibold text-foreground">Avisos da Empresa</h2>
        </div>
        
        <Button variant="ghost" size="sm" asChild className="text-primary">
          <Link to="/announcements">
            Ver todos
            <ChevronRight className="h-4 w-4 ml-1" />
          </Link>
        </Button>
      </div>
      
      <div className="space-y-3">
        {announcements.map((announcement) => (
          <AnnouncementCard key={announcement.id} announcement={announcement} />
        ))}
      </div>
    </section>
  );
}
